import { keysAsValues } from '../../utils';

export const DOCUMENT_DUNNING_LEVEL_INDEXES = {
  FINAL_DUNNING: 3,
  FIRST_DUNNING: 2,
  NO_DUNNING: 0,
  REMINDER: 1,
} as const;

export const DOCUMENT_DUNNING_LEVEL_VALUES = keysAsValues(DOCUMENT_DUNNING_LEVEL_INDEXES);

export type DocumentDunningLevel = keyof typeof DOCUMENT_DUNNING_LEVEL_INDEXES;

export type DocumentDunningLevelIndex = typeof DOCUMENT_DUNNING_LEVEL_INDEXES[keyof typeof DOCUMENT_DUNNING_LEVEL_INDEXES];
